import React, { useEffect, useState } from "react";
import "./Home.css";
// import Header from "../Header/Header";
// import Footer from "../Footer/Footer";
import { API_URL } from "../../Config";
import { services } from "../../Config";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { motion as m } from "framer-motion";
import { PiInstagramLogoFill } from "react-icons/pi";
import { IoLogoWhatsapp } from "react-icons/io";
import { FaLinkedinIn } from "react-icons/fa6";
import { FaFacebookSquare } from "react-icons/fa";
import {
  FaRobot,
  FaFileInvoice,
  FaTasks,
  FaCheckCircle,
  FaMapMarkerAlt,
  FaSyncAlt,
} from "react-icons/fa";
// import { RiCustomerService2Fill } from "react-icons/ri";
// import { SiTicktick } from "react-icons/si";
// import { MdOutlineCircle } from "react-icons/md";
import { ImQuotesLeft } from "react-icons/im";
import { ImQuotesRight } from "react-icons/im";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
// import { ChevronLeft, ChevronRight } from "lucide-react";
import { ImLinkedin } from "react-icons/im";

import Lottie from "lottie-react";
import bg_circle from "../../animations/bg_circle.json";
import HowItWorks from "./HowItWorks";
import { Blogs_data } from "../../Config";
import { Link } from "react-router-dom";

// const milestones = [1, 2, 3, 4, 5];

// const milestoneLabels = {
//   1: "Meeting",
//   2: "Ideation",
//   3: "Coding",
//   4: "Debugging",
//   5: "Scaling",
// };

// const animations = ["meeting", "ideation", "coding", "debug", "scalling"];

const Home = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [visibleCount, setVisibleCount] = useState(8);
  const [isExpanded, setIsExpanded] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 1024) {
        setVisibleCount(4);
        setIsExpanded(false);
      } else {
        setVisibleCount(8);
        setIsExpanded(false);
      }
    };

    handleResize(); // Initial check
    window.addEventListener("resize", handleResize); // Listen on resize

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // const ourService = [
  //   {
  //     title: "Website Designing & Development",
  //     description:
  //       "No more looking around- Init Technology brings you an affordable destination for Modern and Chic Web Development Solutions.",
  //     icon: <FaCode />,
  //     viewMore: true,
  //   },
  //   {
  //     title: "E-Commerce Development",
  //     description:
  //       "From user-friendly interfaces to payment integration and mobile responsiveness, we'll ensure that your e-commerce website is optimised for success.",
  //     icon: <FaShoppingCart />,
  //     viewMore: true,
  //   },
  //   {
  //     title: "Software Development",
  //     description:
  //       "Whether you need a custom web application, mobile app, or enterprise software solution, we have the expertise to bring your vision to life.",
  //     icon: <FaLaptopCode />,
  //     viewMore: true,
  //   },
  //   {
  //     title: "Mobile App Development",
  //     description:
  //       "We leverage the latest technologies and best practices to ensure that your app is not only functional but also scalable, secure, and user-friendly.",
  //     icon: <FaMobile />,
  //     viewMore: true,
  //   },
  //   {
  //     title: "Written Production",
  //     description:
  //       "We understand the power of words, from writing captivating content for your website, engaging articles for your blog, or polished copy for your marketing materials, our team of experienced writers.",
  //     icon: <FaPen />,
  //     viewMore: true,
  //   },
  //   {
  //     title: "Management Services",
  //     description:
  //       "Explore our management services below to learn how we can support your organisation's growth and development.",
  //     icon: <FaCogs />,
  //     viewMore: true,
  //   },
  //   {
  //     title: "WordPress",
  //     description:
  //       "Work with our experienced designers to create a unique and visually stunning website that reflects your brand identity.",
  //     icon: <FaWordpress />,
  //     viewMore: true,
  //   },
  //   {
  //     title: "SEO",
  //     description:
  //       "With millions of websites competing for attention online, it's crucial to ensure that your website ranks well in search engine results to attract organic traffic and reach your target audience effectively.",
  //     icon: <FaChartLine />,
  //     viewMore: true,
  //   },
  //   {
  //     title: "Data Engineering and Analytics",
  //     description:
  //       "We assist you in understanding your data into valuable insights through data pipelines, predictive analytics, and business intelligence solutions. Together, let's make informed, data-driven decisions!",
  //     icon: <FaDatabase />,
  //     viewMore: false,
  //   },
  //   {
  //     title: "SaaS Development",
  //     description:
  //       "Have a fantastic concept for a cloud-based SaaS platform? We're ready to create scalable, multi-tenant applications with smooth APIintegrations that evolve alongside your business.",
  //     icon: <FaCloud />,
  //     viewMore: false,
  //   },
  //   {
  //     title: "Cybersecurity Services",
  //     description:
  //       "Ensure your business's safety with our professional cybersecurity services. We offer everything from vulnerability assessments to compliance consulting, helping you safeguard your data and systems against cyber threats.",
  //     icon: <FaUserShield />,
  //     viewMore: false,
  //   },
  //   {
  //     title: "IT Staff Augmentation",
  //     description:
  //       "Are you looking to expand your team? Our talented IT professionals are prepared to step in and achieve results. Whether you need software developers, designers, or tech consultants, we have the expertise you're seeking.",
  //     icon: <FaUsers />,
  //     viewMore: false,
  //   },
  //   {
  //     title: "IoT Solutions",
  //     description:
  //       "Embrace the future with IoT-enabled systems! We focus on integrating smart devices, providing real-time monitoring, and developing IoT applications to enhance your operations and connect your business.",
  //     icon: <FaRobot />,
  //     viewMore: false,
  //   },
  //   {
  //     title: "AI-Powered Solutions",
  //     description:
  //       "Enhance your operations with AI tools such as smart chatbots, machine learning systems, and AI-driven suggestions. Together, we can introduce innovation to your business!",
  //     icon: <FaBrain />,
  //     viewMore: false,
  //   },
  //   {
  //     title: "Digital Product Design",
  //     description:
  //       "Exceptional UI/UX design is essential for capturing user interest. Init develops digital experiences that resonate with your brand and bring joy to your customers, ranging from interactive prototypes to stunning interfaces.",
  //     icon: <FaPalette />,
  //     viewMore: false,
  //   },
  //   {
  //     title: "IT Consulting Services",
  //     description:
  //       "Technology can feel daunting, but our IT consulting specialists simplify the process. We assist you with IT strategy development, optimising your infrastructure, and creating customised solutions that lead to success.",
  //     icon: <RiCustomerService2Fill />,
  //     viewMore: false,
  //   },
  // ];

  // const [currentStep, setCurrentStep] = useState(1);
  // const [selectedAnimation, setSelectedAnimation] = useState(animations[0]);
  // const [fade, setFade] = useState(false);
  // const sectionRef = useRef(null);
  // const [isVisible, setIsVisible] = useState(false);

  // const handleOnClick = (milestone) => {
  //   setCurrentStep(milestone);
  //   setSelectedAnimation(animations[milestone - 1]);
  // };

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     if (isVisible) {
  //       setFade(true);
  //       setTimeout(() => {
  //         setSelectedAnimation((prev) => {
  //           const currentIndex = animations.indexOf(prev);
  //           const nextIndex = (currentIndex + 1) % animations.length;
  //           setCurrentStep(nextIndex + 1);
  //           return animations[nextIndex];
  //         });
  //         setFade(false);
  //       }, 400); // fade effect
  //     }
  //   }, 3000); // every 3 seconds

  //   return () => clearInterval(interval);
  // }, [isVisible]);

  // useEffect(() => {
  //   const currentSection = sectionRef.current;

  //   const observer = new IntersectionObserver(
  //     ([entry]) => {
  //       setIsVisible(entry.isIntersecting);
  //     },
  //     { threshold: 0.1 }
  //   );

  //   if (currentSection) {
  //     observer.observe(currentSection);
  //   }

  //   return () => {
  //     if (currentSection) {
  //       observer.unobserve(currentSection);
  //     }
  //   };
  // }, []);

  const ourClients = [
    {
      logo: "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/57fb91a3-3a6b-445c-d943-c23e952cdf00/public", //Init_logo_rpj.webp
      white_logo:
        "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/57fb91a3-3a6b-445c-d943-c23e952cdf00/public", //Init_logo_rpj.webp
      link: "rpj-hotel",
    },
    {
      logo: "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/db29e86c-bccb-44c8-af08-e385f7951b00/public", //Init_logo_dresswala.webp
      white_logo:
        "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/8e6e9092-eb39-42df-fec7-c9ab869c5a00/public", // Init_logo_dresswala_white.webp
      link: "dresswala-nx",
    },
    {
      logo: "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/dda040af-bfff-4421-6338-5389b6b89e00/public", //Init_logo_dla.webp
      white_logo:
        "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/dda040af-bfff-4421-6338-5389b6b89e00/public", // Init_logo_dla.webp
      link: "dilip-ladani-associates",
    },
    {
      logo: "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/28d87ae5-1ed4-40b7-22c9-11cd8f7c4300/public", //Init_logo_transGlobe.webp
      white_logo:
        "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/85a5dd3c-0f7f-4dc6-8685-5a8d8823da00/public", // Init_logo_transGlobe_white.webp
      link: "trans-globe",
    },
    {
      logo: "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/383cd306-53a5-4228-5aa2-b2ec553fcb00/public", //Init_logo_sohamVillas.webp
      white_logo:
        "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/d84f0cec-3697-4910-0ffc-a8af66f8ba00/public", // Init_logo_sohamVillas_white.webp
      link: "soham-villas",
    },
    {
      logo: "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/fd16ca85-2ecc-4b97-2072-8a66843e6500/public", //Init_logo_neelAyurvedics.webp
      white_logo:
        "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/75401c88-9cd4-4995-cde3-f00f7377fa00/public", // Init_logo_neelAyurvedics_white.webp
      link: "neel-ayurvedics",
    },
    // {
    //   logo: "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/9ad4087d-7760-4198-3126-df5c4875d000/public", //Init_logo_hariAum.webp
    //   white_logo:
    //     "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/9ad4087d-7760-4198-3126-df5c4875d000/public", // Init_logo_hariAum.webp
    //   link: "hari-aum-designs",
    // },
    {
      logo: "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/e7c0773e-6ce7-4418-74aa-063c81d52600/public", //Init_logo_openStudios.webp
      white_logo:
        "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/d97b9f04-1043-401d-03c0-9d2c023ba700/public", // Init_logo_openStudios_white.webp
      link: "open-studios",
    },
    {
      logo: "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/f0764662-e5fa-4206-bfe9-833f5f901500/public", //Init_logo_houseOfShah.webp
      white_logo:
        "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/5b688f78-d3b6-4e0d-f087-e43c0a8e5400/public", // Init_logo_houseOfShah_white.webp
      link: "house-of-shah",
    },
    // {
    //   logo: "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/d965dc7a-d1d2-40f7-6e90-1769f4870a00/public", //Init_logo_magicMetals.webp
    //   white_logo:
    //     "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/7ace9cb8-2fce-4a91-41b5-6af41d972800/public", // Init_logo_magicMetals_white.webp
    //   link: "magic-metals",
    // },
    {
      logo: "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/19a7ffbc-e70b-4805-4781-eddda0414500/public", //Init_logo_zorbaStays.webp
      white_logo:
        "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/f03d4c87-feed-4cdd-9f75-0dfd8f70fa00/public", // Init_logo_zorbaStays_white.webp
      link: "zorba-stays",
    },
  ];

  const responsiveForClients = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 1536 },
      items: 6,
    },
    xl: {
      breakpoint: { max: 1536, min: 1280 },
      items: 5,
    },
    lg: {
      breakpoint: { max: 1280, min: 1024 },
      items: 4,
    },
    md: {
      breakpoint: { max: 1024, min: 768 },
      items: 4,
    },
    sm: {
      breakpoint: { max: 768, min: 640 },
      items: 3,
    },
    xs: {
      breakpoint: { max: 640, min: 426 },
      items: 2,
    },
    xxs: {
      breakpoint: { max: 425, min: 0 },
      items: 1.5,
    },
  };

  // const testimonials = [
  //   {
  //     id: 1,
  //     name: "- Mr. Neel Kamdar, Neel Ayurvedics",
  //     description:
  //       "INIT developed our software exactly as proposed, delivering it on time with excellent support. The team was highly responsive, receptive to feedback, and proactive in resolving any challenges. The final product fully met our expectations.",
  //     logo: "https://upload.wikimedia.org/wikipedia/commons/2/2f/Google_2015_logo.svg",
  //   },
  //   {
  //     id: 2,
  //     name: "- Mr. Ajayrajsinh Jadeja, RPJ Hotels",
  //     description:
  //       "We collaborated with INIT Technology to build the RPJ Hotel website, and the experience was excellent. The team was professional, attentive, and understood our vision, even suggesting creative enhancements. The end result is a visually appealing and user-friendly website that received great feedback. The project was delivered on time, and they were responsive to our needs throughout. Highly recommend INIT Technology.",
  //     logo: "https://upload.wikimedia.org/wikipedia/commons/4/44/Microsoft_logo.svg",
  //   },
  //   {
  //     id: 3,
  //     name: "Apple",
  //     description: "Think different. Creating next-gen experiences.",
  //     logo: "https://upload.wikimedia.org/wikipedia/commons/f/fa/Apple_logo_black.svg",
  //   },
  // ];

  // const [index, setIndex] = useState(0);

  // const nextSlide = () => {
  //   setIndex((prev) => (prev + 1) % testimonials.length);
  // };

  // const prevSlide = () => {
  //   setIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  // };

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     setIndex((prev) => (prev + 1) % testimonials.length);
  //   }, 6000);

  //   return () => clearInterval(interval);
  // }, [testimonials.length]);

  const [testimonials, setTestimonials] = useState([]);

  useEffect(() => {
    const fetchTestimonials = async () => {
      try {
        const response = await fetch(API_URL + "/getTestimonials");
        if (!response.ok) {
          throw new Error(
            `Failed to fetch testimonials: ${response.status} ${response.statusText}`
          );
        }
        const data = await response.json();
        setTestimonials(data);
      } catch (error) {
        console.error("Error fetching testimonials:", error);
      }
    };

    fetchTestimonials();
  }, []);

  const responsiveTestimonial = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 1,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 1,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 1,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };

  const CustomDot = ({ onClick, active }) => (
    <button
      onClick={onClick}
      className={`md:hidden w-2 h-2 mx-0.5 my-1 rounded-full transition-all duration-300 ease-in-out ${
        active ? "bg-teal-600 scale-110" : "bg-gray-400 dark:bg-gray-600"
      }`}
    />
  );

  const [activeTab, setActiveTab] = useState("QuotSync");

  const ourProducts = {
    QuotSync: [
      {
        icon: <FaRobot className="text-teal-600 text-3xl sm:text-4xl mb-4" />,
        title: "AI Integrated",
        desc: "Smart automation to simplify your workflow.",
      },
      {
        icon: (
          <FaFileInvoice className="text-teal-600 text-3xl sm:text-4xl mb-4" />
        ),
        title: "Automate Quotations",
        desc: "Create professional quotations on the go.",
      },
      {
        icon: <FaTasks className="text-teal-600 text-3xl sm:text-4xl mb-4" />,
        title: "Ease of Management",
        desc: "Streamlined handling of invoices & more.",
      },
      {
        icon: (
          <FaCheckCircle className="text-teal-600 text-3xl sm:text-4xl mb-4" />
        ),
        title: "Accurate Quotes Instantly",
        desc: "Generate precise quotes in seconds.",
      },
    ],
    "Waverise Hub": [
      {
        icon: <FaTasks className="text-teal-600 text-3xl sm:text-4xl mb-4" />,
        title: "Task, Performance Management & More",
        desc: "Manage teams efficiently and boost productivity.",
      },
      {
        icon: (
          <FaMapMarkerAlt className="text-teal-600 text-3xl sm:text-4xl mb-4" />
        ),
        title: "Track Location",
        desc: "Monitor and track employee or asset locations.",
      },
      {
        icon: <FaSyncAlt className="text-teal-600 text-3xl sm:text-4xl mb-4" />,
        title: "Real-time Updates & Tracking",
        desc: "Stay informed with live updates and progress.",
      },
      {
        icon: (
          <FaCheckCircle className="text-teal-600 text-3xl sm:text-4xl mb-4" />
        ),
        title: "Accurate Quotes Instantly",
        desc: "Generate precise quotes instantly.",
      },
    ],
  };

  const responsive_blogs = {
    "2xl": {
      breakpoint: { max: 4000, min: 1536 },
      items: 4,
      partialVisibilityGutter: 30,
    },
    xl: {
      breakpoint: { max: 1536, min: 1280 },
      items: 3,
      partialVisibilityGutter: 30,
    },
    lg: {
      breakpoint: { max: 1280, min: 1024 },
      items: 2,
      partialVisibilityGutter: 50,
    },
    md: {
      breakpoint: { max: 1024, min: 768 },
      items: 2,
      partialVisibilityGutter: 50,
    },
    sm: {
      breakpoint: { max: 768, min: 640 },
      items: 1.5,
      partialVisibilityGutter: 50,
    },
    xs: {
      breakpoint: { max: 640, min: 0 },
      items: 1,
      partialVisibilityGutter: 10,
    },
  };

  return (
    <m.div
      initial={{ opacity: 0 }}
      animate={{ opacity: [0, 0.5, 1] }}
      transition={{ duration: 0.9, ease: "easeIn" }}
      style={{ willChange: "opacity" }}
    >
      {/* <Header /> */}

      <div className="bg-white dark:bg-black dark:text-white transition-all duration-300 ease-in-out">
        {/* Banner */}
        <div className="relative w-full h-[100vh] overflow-hidden">
          <div className="absolute right-0 top-0 h-full">
            <img
              src="../assets/init_bannerBg_light.webp" // init_bannerBg_light.webp
              alt="Light Background"
              className="w-full h-full object-[70%_center] object-cover block dark:hidden"
            />

            <img
              src="../assets/init_bannerBg_dark.webp" // init_bannerBg_dark.webp
              alt="Dark Background"
              className="w-full h-full object-[70%_center] object-cover hidden dark:block"
            />
          </div>

          <div className="w-full h-full px-5 lg:px-[6%]">
            <div className="h-full grid items-center">
              <div className="relative z-10">
                <p className="font-bold text-4xl md:text-5xl lg:text-6xl 2xl:text-7xl mt-24 transition-all duration-300 ease-in-out">
                  <span className="InitLogo_font text-teal-700">iNIT</span> for
                  the long run
                </p>
                <p className="mt-10 text-gray-700 dark:text-gray-300">
                  See what happens when technology meets your Vision
                </p>

                <div className="flex items-center mt-5">
                  <a href="#services" className="relative group">
                    <button className="relative inline-block p-px text-white bg-[#008080] cursor-pointer rounded-lg shadow-emerald-900 transition-all duration-300 ease-in-out hover:scale-105 active:scale-95 hover:shadow-emerald-600">
                      <span className="absolute inset-0 rounded-lg bg-gradient-to-r from-teal-100 via-teal-300 to-teal-500 p-[2px] opacity-0 transition-opacity duration-500 group-hover:opacity-100"></span>
                      <span className="relative z-10 block px-6 py-3 rounded-lg bg-[#008080]">
                        <div className="relative z-10 flex items-center space-x-3">
                          <span className="font-medium transition-all duration-500 group-hover:translate-x-1.5 text-sm group-hover:text-white">
                            Discover more
                          </span>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            fill="currentColor"
                            className="w-4 h-4 transition-all duration-500 group-hover:translate-x-1.5 text-sm group-hover:text-white"
                          >
                            <path d="M16.172 11l-5.364-5.364 1.414-1.414L20 12l-7.778 7.778-1.414-1.414L16.172 13H4v-2z"></path>
                          </svg>
                        </div>
                      </span>
                    </button>
                  </a>
                </div>

                <p
                  className="text-sm text-gray-400 max-w-96 2xl:max-w-[600px] mt-10 sm:mt-20"
                  style={{ wordSpacing: "5px", lineHeight: 2 }}
                >
                  HTML CSS PHP JAVA DATABASE MySQL PostgreSQL FIGMA SHOPIFY
                  Node.JS WORDPRESS Angular ReactJS React-Native FRAMER
                  TypeScript Spring-Boot
                </p>
              </div>
            </div>
          </div>

          <div className="absolute bottom-5 sm:bottom-8 left-4 lg:left-[5%] flex gap-2 mt-10">
            <div className="flex items-center">
              <a
                href="https://www.linkedin.com/company/init-technologyco"
                target="_blank"
                rel="noopener noreferrer"
                className="group scale-90 w-11 hover:w-32 h-10 hover:bg-white/0 dark:hover:bg-black/0 relative backdrop-blur-md bg-white/0 dark:bg-black/0 rounded text-neutral-50 duration-700 before:duration-700 before:hover:500 font-bold flex justify-start gap-2 items-center p-2 pr-6 before:absolute before:-z-10 before:left-7 before:hover:left-32 before:w-6 before:h-5 before:scale-0 before:bg-white dark:before:bg-black before:hover:bg-white dark:before:hover:bg-black before:rotate-45"
              >
                <FaLinkedinIn className="w-7 h-7 shrink-0 fill-black dark:fill-white group-hover:fill-sky-600" />
                <span className="origin-left text-sky-600 inline-flex duration-100 group-hover:duration-300 group-hover:delay-500 opacity-0 group-hover:opacity-100 border-sky-600 border-l-2 px-1 transform scale-x-0 group-hover:scale-x-100 transition-all">
                  LinkedIn
                </span>
              </a>
            </div>

            <div className="flex items-center">
              <a
                href="https://www.instagram.com/init.technology"
                target="_blank"
                rel="noopener noreferrer"
                className="group scale-90 w-11 hover:w-32 h-10 hover:bg-white/0 dark:hover:bg-black/0 relative backdrop-blur-md bg-white/0 dark:bg-black/0 rounded text-neutral-50 duration-700 before:duration-700 before:hover:500 font-bold flex justify-start gap-2 items-center p-2 pr-6 before:absolute before:-z-10 before:left-7 before:hover:left-32 before:w-6 before:h-5 before:scale-0 before:bg-white dark:before:bg-black before:hover:bg-white dark:before:hover:bg-black before:rotate-45"
              >
                <PiInstagramLogoFill className="w-7 h-7 shrink-0 text-black dark:text-white group-hover:text-pink-600 bg-gradient-to-r from-yellow-400 via-pink-500 to-purple-600 bg-clip-text" />
                <span className="origin-left text-pink-600 inline-flex duration-100 group-hover:duration-300 group-hover:delay-500 opacity-0 group-hover:opacity-100 border-pink-600 border-l-2 px-1 transform scale-x-0 group-hover:scale-x-100 transition-all">
                  Instagram
                </span>
              </a>
            </div>

            <div className="flex items-center">
              <a
                href="https://wa.me/+919664570369?text=Hi%20Init%20Technology,%20I`m%20on%20the%20lookout%20for%20innovative%20solutions,%20and%20your%20services%20caught%20my%20eye.%20Can%20we%20chat%20about%20it%20?"
                target="_blank"
                rel="noopener noreferrer"
                className="group scale-90 w-11 hover:w-32 h-10 hover:bg-white/0 dark:hover:bg-black/0 relative backdrop-blur-md bg-white/0 dark:bg-black/0 rounded text-neutral-50 duration-700 before:duration-700 before:hover:500 font-bold flex justify-start gap-2 items-center p-2 pr-6 before:absolute before:-z-10 before:left-7 before:hover:left-32 before:w-6 before:h-5 before:scale-0 before:bg-white dark:before:bg-black before:hover:bg-white dark:before:hover:bg-black before:rotate-45"
              >
                <IoLogoWhatsapp className="w-7 h-7 shrink-0 fill-black dark:fill-white group-hover:fill-green-600" />
                <span className="origin-left text-green-600 inline-flex duration-100 group-hover:duration-300 group-hover:delay-500 opacity-0 group-hover:opacity-100 border-green-600 border-l-2 px-1 transform scale-x-0 group-hover:scale-x-100 transition-all">
                  WhatsApp
                </span>
              </a>
            </div>

            <div className="flex items-center">
              <a
                href="https://www.facebook.com/profile.php?id=61554743413903&mibextid=9R9pXO"
                target="_blank"
                rel="noopener noreferrer"
                className="group scale-90 w-11 hover:w-32 h-10 hover:bg-white/0 dark:hover:bg-black/0 relative backdrop-blur-md bg-white/0 dark:bg-black/0 rounded text-neutral-50 duration-700 before:duration-700 before:hover:500 font-bold flex justify-start gap-2 items-center p-2 pr-6 before:absolute before:-z-10 before:left-7 before:hover:left-32 before:w-6 before:h-5 before:scale-0 before:bg-white dark:before:bg-black before:hover:bg-white dark:before:hover:bg-black before:rotate-45"
              >
                <FaFacebookSquare className="w-7 h-7 shrink-0 fill-black dark:fill-white group-hover:fill-blue-700" />
                <span className="origin-left text-blue-700 inline-flex duration-100 group-hover:duration-300 group-hover:delay-500 opacity-0 group-hover:opacity-100 border-blue-700 border-l-2 px-1 transform scale-x-0 group-hover:scale-x-100 transition-all">
                  Facebook
                </span>
              </a>
            </div>
          </div>

          {/* <div className="absolute hidden md:block right-4 top-[70vh] h-full">
            <div className="flex items-center">
              <a
                href="/"
                target="_blank"
                rel="noopener noreferrer"
                className="group scale-90 w-11 hover:w-36 h-10 hover:bg-white/70 dark:hover:bg-black/50 relative backdrop-blur-md bg-white/50 dark:bg-black/50 rounded text-neutral-50 duration-700 before:duration-700 before:hover:500 font-bold flex justify-start gap-2 items-center p-2 pr-6 before:absolute before:-z-10 before:left-7 before:hover:left-32 before:w-6 before:h-5 before:scale-0 before:bg-white dark:before:bg-black before:hover:bg-white dark:before:hover:bg-black before:rotate-45"
              >
                <FaLinkedinIn className="w-7 h-7 shrink-0 fill-teal-700 group-hover:fill-sky-600" />
                <span className="origin-left text-sky-600 inline-flex duration-100 group-hover:duration-300 group-hover:delay-500 opacity-0 group-hover:opacity-100 border-sky-600 border-l-2 px-1 transform scale-x-0 group-hover:scale-x-100 transition-all">
                  LinkedIn
                </span>
              </a>
            </div>
          </div>

          <div className="absolute hidden md:block right-4 top-[77vh] h-full">
            <div className="flex items-center">
              <a
                href="/"
                target="_blank"
                rel="noopener noreferrer"
                className="group scale-90 w-11 hover:w-36 h-10 hover:bg-white/70 dark:hover:bg-black/50 relative backdrop-blur-md bg-white/50 dark:bg-black/50 rounded text-neutral-50 duration-700 before:duration-700 before:hover:500 font-bold flex justify-start gap-2 items-center p-2 pr-6 before:absolute before:-z-10 before:left-7 before:hover:left-32 before:w-6 before:h-5 before:scale-0 before:bg-white dark:before:bg-black before:hover:bg-white dark:before:hover:bg-black before:rotate-45"
              >
                <FaInstagram className="w-7 h-7 shrink-0 text-teal-700 group-hover:text-pink-600 bg-gradient-to-r from-yellow-400 via-pink-500 to-purple-600 bg-clip-text" />
                <span className="origin-left text-pink-600 inline-flex duration-100 group-hover:duration-300 group-hover:delay-500 opacity-0 group-hover:opacity-100 border-pink-600 border-l-2 px-1 transform scale-x-0 group-hover:scale-x-100 transition-all">
                  Instagram
                </span>
              </a>
            </div>
          </div>

          <div className="absolute hidden md:block right-4 top-[84vh] h-full">
            <div className="flex items-center">
              <a
                href="/"
                target="_blank"
                rel="noopener noreferrer"
                className="group scale-90 w-11 hover:w-36 h-10 hover:bg-white/70 dark:hover:bg-black/50 relative backdrop-blur-md bg-white/50 dark:bg-black/50 rounded text-neutral-50 duration-700 before:duration-700 before:hover:500 font-bold flex justify-start gap-2 items-center p-2 pr-6 before:absolute before:-z-10 before:left-7 before:hover:left-32 before:w-6 before:h-5 before:scale-0 before:bg-white dark:before:bg-black before:hover:bg-white dark:before:hover:bg-black before:rotate-45"
              >
                <FaWhatsapp className="w-7 h-7 shrink-0 fill-teal-700 group-hover:fill-green-600" />
                <span className="origin-left text-green-600 inline-flex duration-100 group-hover:duration-300 group-hover:delay-500 opacity-0 group-hover:opacity-100 border-green-600 border-l-2 px-1 transform scale-x-0 group-hover:scale-x-100 transition-all">
                  WhatsApp
                </span>
              </a>
            </div>
          </div>

          <div className="absolute hidden md:block right-4 top-[91vh] h-full">
            <div className="flex items-center">
              <a
                href="/"
                target="_blank"
                rel="noopener noreferrer"
                className="group scale-90 w-11 hover:w-36 h-10 hover:bg-white/70 dark:hover:bg-black/50 relative backdrop-blur-md bg-white/50 dark:bg-black/50 rounded text-neutral-50 duration-700 before:duration-700 before:hover:500 font-bold flex justify-start gap-2 items-center p-2 pr-6 before:absolute before:-z-10 before:left-7 before:hover:left-32 before:w-6 before:h-5 before:scale-0 before:bg-white dark:before:bg-black before:hover:bg-white dark:before:hover:bg-black before:rotate-45"
              >
                <FaFacebookSquare className="w-7 h-7 shrink-0 fill-teal-700 group-hover:fill-blue-700" />
                <span className="origin-left text-blue-700 inline-flex duration-100 group-hover:duration-300 group-hover:delay-500 opacity-0 group-hover:opacity-100 border-blue-700 border-l-2 px-1 transform scale-x-0 group-hover:scale-x-100 transition-all">
                  Facebook
                </span>
              </a>
            </div>
          </div> */}
        </div>

        <span id="services" />

        {/* Our Services */}
        <div className="px-5 lg:px-[10%] 2xl:px-[15%] pt-20 pb-10">
          <p className="font-semibold text-3xl lg:text-4xl transition-all duration-200 ease-in-out">
            Our Services
            <div className="flex h-0.5 w-10 mt-0.5 bg-teal-600 rounded-full" />
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 mt-8">
            {services.slice(0, visibleCount).map((service, index) => (
              <div
                key={index}
                className="relative group p-5 bg-white dark:bg-[#252525] rounded-lg shadow-md hover:shadow-custom dark:hover:shadow-white transition-all duration-300 transform hover:-translate-y-1 overflow-hidden"
              >
                <div className="absolute -bottom-4 -right-3 group-hover:bottom-2 group-hover:right-2 opacity-20 group-hover:opacity-80 transition-all duration-500 ease-in-out text-7xl group-hover:text-5xl text-teal-500">
                  {service.icon}
                </div>

                <h3 className="text-lg text-teal-600 font-semibold mb-2">
                  {service.title}
                </h3>
                <p
                  className="text-sm text-gray-500 dark:text-gray-300 mb-4"
                  style={{ lineHeight: 1.8 }}
                >
                  {service.description}
                </p>

                {service.viewMore ? (
                  <Link
                    key={service.title}
                    to={`/services/${encodeURIComponent(service.serviceLink)}`}
                    className="text-sm mt-3 opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                  >
                    View more
                    <div className="h-0.5 w-14 -ml-3 bg-black dark:bg-white transition-all opacity-0 group-hover:opacity-100 duration-500 ease-in-out group-hover:ml-1.5 group-hover:bg-teal-500"></div>
                  </Link>
                ) : (
                  <button
                    className="mt-3 opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                    disabled
                  >
                    Future projects in motion
                    <div className="h-0.5 w-20 -ml-2.5 bg-gray-400"></div>
                  </button>
                )}
              </div>
            ))}
          </div>

          <div className="flex justify-center text-center mt-6">
            {!isExpanded && visibleCount < services.length && (
              <div className="flex items-center">
                <div className="relative group">
                  <button
                    onClick={() => {
                      const newCount = Math.min(
                        visibleCount + 4,
                        services.length
                      );
                      setVisibleCount(newCount);
                      if (newCount === services.length) setIsExpanded(true);
                    }}
                    className="relative inline-block p-px text-white bg-[#008080] cursor-pointer rounded-lg shadow-emerald-900 transition-all duration-300 ease-in-out hover:scale-105 active:scale-95 hover:shadow-emerald-600"
                  >
                    <span className="absolute inset-0 rounded-lg bg-gradient-to-r from-teal-100 via-teal-300 to-teal-500 p-[2px] opacity-0 transition-opacity duration-500 group-hover:opacity-100"></span>
                    <span className="relative z-10 block px-4 py-2 rounded-lg bg-[#008080]">
                      <div className="relative z-10 flex items-center space-x-3">
                        <span className="font-medium transition-all duration-500 group-hover:translate-x-0 text-sm group-hover:text-white">
                          Load more
                        </span>
                      </div>
                    </span>
                  </button>
                </div>
              </div>
            )}

            {isExpanded && (
              <div className="flex items-center">
                <div className="relative group">
                  <button
                    onClick={() => {
                      setIsExpanded(false);
                      setVisibleCount(window.innerWidth < 1024 ? 4 : 8);
                    }}
                    className="relative inline-block p-px text-white bg-teal-900 cursor-pointer rounded-lg shadow-emerald-900 transition-all duration-300 ease-in-out hover:scale-105 active:scale-95 hover:shadow-emerald-600"
                  >
                    <span className="absolute inset-0 rounded-lg bg-gradient-to-r from-teal-100 via-teal-400 to-teal-700 p-[2px] opacity-0 transition-opacity duration-500 group-hover:opacity-100"></span>
                    <span className="relative z-10 block px-4 py-2 rounded-lg bg-teal-900">
                      <div className="relative z-10 flex items-center space-x-3">
                        <span className="font-medium transition-all duration-500 group-hover:translate-x-0 text-sm group-hover:text-white">
                          Show less
                        </span>
                      </div>
                    </span>
                  </button>
                </div>
              </div>
            )}
            <span id="how-it-works" />
          </div>
        </div>

        {/* How it Works */}
        <div className="px-5 lg:px-[10%] 2xl:px-[15%] py-10">
          <div className="border border-black dark:border-white rounded-lg px-5 lg:px-10">
            <HowItWorks />
          </div>
        </div>

        {/* Clients Who Trust Us */}
        <div className="px-5 lg:px-[10%] 2xl:px-[15%] py-10">
          <p className="font-semibold text-3xl lg:text-4xl transition-all duration-200 ease-in-out">
            Clients Who Trust Us
            <div className="flex h-0.5 w-10 mt-0.5 bg-teal-600 rounded-full" />
          </p>

          <div className="w-full mt-5">
            <Carousel
              responsive={responsiveForClients}
              infinite={true}
              autoPlay
              autoPlaySpeed={2000}
              pauseOnHover
              arrows={false}
              draggable
              showDots={false}
              removeArrowOnDeviceType={["tablet", "mobile"]}
            >
              {ourClients.map((item, index) => (
                <div className="flex items-center justify-center m-4 bg-white dark:bg-[#252525] rounded-md shadow-md transition-transform duration-300 hover:scale-105">
                  <a
                    key={index}
                    href={`/project-case-study/${item.link}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {/* Light Logo */}
                    <img
                      src={item.logo}
                      alt="project-logo"
                      loading="lazy"
                      className="aspect-[5/4] object-contain dark:hidden group-hover:scale-90 transition-all duration-500 ease-in-out"
                    />

                    {/* Dark Logo */}
                    <img
                      src={item.white_logo}
                      alt="project-logo-dark"
                      loading="lazy"
                      className="aspect-[5/4] object-contain hidden dark:block group-hover:scale-90 transition-all duration-500 ease-in-out"
                    />
                    {/* <img
                      src={item.src}
                      alt={`client-${index}`}
                      className="aspect-[4/3] object-contain object-center"
                    /> */}
                  </a>
                </div>
              ))}
            </Carousel>
          </div>

          <span id="products" />
        </div>

        {/* Our Products */}
        <div className="px-5 lg:px-[10%] 2xl:px-[15%] py-10">
          <p className="font-semibold text-3xl lg:text-4xl transition-all duration-200 ease-in-out">
            Our Products
            <div className="flex h-0.5 w-10 mt-0.5 bg-teal-600 rounded-full" />
          </p>

          <div className="flex justify-center gap-10 my-6 text-lg font-semibold">
            {Object.keys(ourProducts).map((tab) => (
              <button
                key={tab}
                onClick={() => setActiveTab(tab)}
                className={`pb-0.5 transition ${
                  activeTab === tab
                    ? "text-black dark:text-white border-b-[1.5px] border-teal-600"
                    : "text-gray-500 hover:text-teal-600"
                }`}
              >
                {tab}
              </button>
            ))}
          </div>

          <p className="text-center text-gray-600 dark:text-gray-300 mb-10 mx-auto max-w-[650px] leading-relaxed">
            {activeTab === "QuotSync"
              ? "QuotSync – your essential invoice management software."
              : "WaveRise Hub empowers you to track your team's performance, ensure accountability, and optimise productivity—all without the need for micromanagement."}
          </p>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-5 lg:gap-8">
            {ourProducts[activeTab].map((product, index) => (
              <div
                key={index}
                className="relative flex flex-col items-center bg-white dark:bg-black border dark:border-gray-700 
                 rounded-lg shadow-md dark:shadow-white/30 p-6 text-center 
                 hover:shadow-lg hover:-translate-y-2 transition-all duration-500 overflow-hidden"
              >
                <div className="absolute -top-36 -left-16 flex justify-center items-center z-0 pointer-events-none">
                  <Lottie
                    animationData={bg_circle}
                    loop={true}
                    autoplay={true}
                    className="h-[250px] w-[250px] opacity-30"
                    rendererSettings={{
                      preserveAspectRatio: "xMidYMid slice",
                    }}
                  />
                </div>

                <div className="absolute -bottom-12 -right-10 flex justify-center items-center z-0 pointer-events-none">
                  <Lottie
                    animationData={bg_circle}
                    loop={true}
                    autoplay={true}
                    className="h-[100px] w-[100px] opacity-60"
                    rendererSettings={{
                      preserveAspectRatio: "xMidYMid slice",
                    }}
                  />
                </div>

                <div className="relative flex flex-col text-left sm:text-center sm:items-center z-10">
                  <div className="absolute -top-4 -right-3 sm:static sm:mb-0">
                    {product.icon}
                  </div>
                  <h3 className="font-semibold text-lg my-3 text-black dark:text-white">
                    {product.title}
                  </h3>
                  <p className="text-gray-600 dark:text-gray-400 text-sm">
                    {product.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>

          <div className="flex justify-center items-center mt-5">
            <div className="relative group">
              <button className="relative inline-block p-px text-white bg-[#008080] cursor-default rounded-lg shadow-emerald-900 transition-all duration-300 ease-in-out hover:shadow-emerald-600">
                <span className="absolute inset-0 rounded-lg bg-gradient-to-r from-teal-100 via-teal-300 to-teal-500 p-[2px] opacity-0 transition-opacity duration-500 group-hover:opacity-100"></span>
                <span className="relative z-10 block px-4 py-2 rounded-lg bg-[#008080]">
                  <div className="relative z-10 flex items-center space-x-3">
                    <span className="font-medium transition-all duration-500 group-hover:translate-x-0 text-sm group-hover:text-white">
                      Coming soon..
                    </span>
                  </div>
                </span>
              </button>
            </div>
          </div>

          {/* <div className="grid grid-cols-2 md:grid-cols-4 gap-5 lg:gap-8">
            {ourProducts[activeTab].map((product, index) => (
              <div
                key={index}
                className="flex flex-col items-center bg-white dark:bg-black border dark:border-gray-700 rounded-lg shadow-md dark:shadow-white/30 p-6 text-center 
                       hover:shadow-lg hover:-translate-y-2 transition-transform duration-300"
              >
                {product.icon}
                <h3 className="font-semibold text-lg my-3 text-black dark:text-white">
                  {product.title}
                </h3>
                <p className="text-gray-600 dark:text-gray-400 text-sm">
                  {product.desc}
                </p>
              </div>
            ))}
          </div> */}
        </div>

        {/* Testimonials */}
        <div className="px-5 lg:px-[7%] 2xl:px-[13%] pb-10">
          <div className="bg-gray-50 dark:bg-[#252525] rounded-lg my-10 p-5 md:p-10 transition-all duration-300 ease-in-out">
            <p className="font-semibold text-3xl lg:text-4xl transition-all duration-200 ease-in-out">
              Testimonials
              <div className="flex h-0.5 w-10 mt-0.5 bg-teal-600 rounded-full" />
            </p>

            <Carousel
              responsive={responsiveTestimonial}
              infinite={true}
              autoPlay={true}
              autoPlaySpeed={8000}
              transitionDuration={1000}
              keyBoardControl={true}
              showDots={true}
              dotListClass="flex justify-center mt-5"
              customDot={<CustomDot />}
              customLeftArrow={
                <button className="hidden md:block absolute left-0 md:left-5 top-1/2 -translate-y-1/2 bg-gray-300 dark:bg-black/30 text-white p-2 rounded-full shadow-lg hover:bg-teal-600 dark:hover:bg-teal-600 transition-all duration-300 ease-in-out">
                  <FaChevronLeft size={12} />
                </button>
              }
              customRightArrow={
                <button className="hidden md:block absolute right-0 md:right-5 top-1/2 -translate-y-1/2 bg-gray-300 dark:bg-black/30 text-white p-2 rounded-full shadow-lg hover:bg-teal-600 dark:hover:bg-teal-600 transition-all duration-300 ease-in-out">
                  <FaChevronRight size={12} />
                </button>
              }
            >
              {testimonials.map((testimonial, index) => (
                <div
                  key={index}
                  className="flex-col items-center my-10 md:mb-0 md:px-20"
                >
                  <ImQuotesLeft />
                  <p className="mx-8 md:mx-20 leading-relaxed">
                    {testimonial.reviews}
                    {testimonial.client_name && (
                      <>
                        <br /> <br />
                        <a
                          href={testimonial.website_link}
                          target="_blank"
                          rel="noreferrer"
                          className="font-semibold cursor-pointer"
                        >
                          - {testimonial.client_name}
                        </a>
                      </>
                    )}
                  </p>
                  <ImQuotesRight className="float-right" />
                </div>
              ))}
            </Carousel>

            <span id="about-us" />
          </div>
        </div>

        {/* About Us */}
        <div className="px-5 lg:px-[10%] 2xl:px-[15%] pb-10">
          <div className="grid grid-cols-1 md:grid-cols-[auto_200px] justify-between gap-10 lg:gap-20 items-start">
            <div className="space-y-8 leading-relaxed lg:max-w-[700px]">
              <p className="font-semibold text-3xl lg:text-4xl transition-all duration-200 ease-in-out">
                About Us
                <div className="flex h-0.5 w-10 mt-0.5 bg-teal-600 rounded-full" />
              </p>

              <p>
                The foundation of Init Technology stemmed from the idea that
                while there are many varieties to choose from in the IT
                industry, only a few stand out and provide quality assurance,
                deliver timely, and communicate consistently throughout a
                project and thereafter!
              </p>

              <p>
                We are committed to building long-term partnerships with our
                clients, providing ongoing support and guidance to help them
                succeed. Our team is intricately chosen based on their
                strengths, enabling us to fulfil these responsibilities with
                excellence.
              </p>
            </div>

            <div className="flex flex-col items-start">
              <p className="font-semibold text-3xl lg:text-2xl transition-all duration-200 ease-in-out">
                Our Team
                <div className="flex h-0.5 w-10 mt-0.5 bg-teal-600 rounded-full" />
              </p>

              <div className="my-8 space-y-5">
                <div>
                  <div className="flex gap-2 items-center mb-1">
                    <p>Mr. Sikandar Bathvar</p>
                    <a href="/">
                      <ImLinkedin
                        size={20}
                        className="text-teal-700 hover:scale-90 transition-all ease-in-out duration-300"
                      />
                    </a>
                  </div>
                  <i>Director</i>
                </div>

                <div>
                  <div className="flex gap-2 items-center mb-1">
                    <p>Ms. Naju Keshwala</p>
                    <a href="/">
                      <ImLinkedin
                        size={20}
                        className="text-teal-700 hover:scale-90 transition-all ease-in-out duration-300"
                      />
                    </a>
                  </div>
                  <i>Director</i>
                </div>
              </div>

              <span id="blogs" />

              <a
                href="/about-us"
                className="flex flex-col md:ml-auto text-sm group"
              >
                View more
                <div className="h-0.5 w-14 -ml-3 bg-black dark:bg-white transition-all duration-500 ease-in-out group-hover:ml-1.5 group-hover:bg-teal-500"></div>
              </a>
            </div>
          </div>
        </div>

        {/* Blogs */}
        <div className="px-5 lg:px-[10%] 2xl:px-[15%] py-10">
          <div className="grid grid-cols-[85%_10%] gap-5 sm:gap-10 justify-between items-center">
            <Carousel
              responsive={responsive_blogs}
              infinite={true}
              autoPlay={true}
              autoPlaySpeed={5000}
              transitionDuration={2000}
              keyBoardControl={true}
              // partialVisbile={true}
              itemClass="px-3 mt-10 mb-2"
              // removeArrowOnDeviceType={["tablet", "mobile"]}
              arrows={false}
            >
              {Blogs_data.map((blog, index) => (
                <a
                  key={index}
                  href={blog.href}
                  className="group bg-white dark:bg-[#252525] p-2 shadow-md hover:shadow-custom dark:hover:shadow-white rounded-lg flex flex-col transition-all duration-300"
                >
                  <img
                    src={blog.imgSrc}
                    alt="Blog-Img"
                    className="w-full aspect-[5/4] object-center object-cover rounded-t-md shadow-custom -mt-8 group-hover:-translate-y-2 transition-all duration-300 ease-in-out"
                    loading="lazy"
                  />

                  <div className="p-1 mt-3">
                    <p className="font-medium text-base 2xl:text-lg line-clamp-2">
                      {blog.title}
                    </p>

                    <p className="text-sm 2xl:text-xl mt-6">{blog.author}</p>
                    <p className="text-[12px] 2xl:text-lg font-light mt-1">
                      {`${blog.date} ∙ ${blog.readTime}`}
                    </p>
                  </div>
                </a>
              ))}
            </Carousel>

            <a href="/blogs" className="rotate-180">
              <button className="button_blogArrow">
                <div className="button-box_blogArrow">
                  <span className="button-elem_blogArrow">
                    <svg viewBox="0 0 46 40" xmlns="http://www.w3.org/2000/svg">
                      <path d="M46 20.038c0-.7-.3-1.5-.8-2.1l-16-17c-1.1-1-3.2-1.4-4.4-.3-1.2 1.1-1.2 3.3 0 4.4l11.3 11.9H3c-1.7 0-3 1.3-3 3s1.3 3 3 3h33.1l-11.3 11.9c-1 1-1.2 3.3 0 4.4 1.2 1.1 3.3.8 4.4-.3l16-17c.5-.5.8-1.1.8-1.9z"></path>
                    </svg>
                  </span>
                  <span className="button-elem_blogArrow">
                    <svg viewBox="0 0 46 40">
                      <path d="M46 20.038c0-.7-.3-1.5-.8-2.1l-16-17c-1.1-1-3.2-1.4-4.4-.3-1.2 1.1-1.2 3.3 0 4.4l11.3 11.9H3c-1.7 0-3 1.3-3 3s1.3 3 3 3h33.1l-11.3 11.9c-1 1-1.2 3.3 0 4.4 1.2 1.1 3.3.8 4.4-.3l16-17c.5-.5.8-1.1.8-1.9z"></path>
                    </svg>
                  </span>
                </div>
              </button>
            </a>
          </div>
        </div>

        {/* <div className="w-full mt-5 mx-auto flex items-center justify-center shadow-custom shadow-black/50 dark:shadow-white rounded-lg overflow-hidden bg-white dark:bg-black">
            {/* Left - Logo 
            <div className="w-1/4 h-full flex items-center justify-center p-8 bg-gray-50 dark:bg-gray-500/10">
              <AnimatePresence mode="wait">
                <m.img
                  key={testimonials[index].id}
                  src={testimonials[index].logo}
                  alt={testimonials[index].name}
                  className="w-32 h-32 object-contain"
                  initial={{ opacity: 0, scale: 0.8 }}
                  animate={{ opacity: 1, scale: 1 }}
                  exit={{ opacity: 0, scale: 0.8 }}
                  transition={{ duration: 0.6 }}
                />
              </AnimatePresence>
            </div>

            {/* Right - Details 
            <div className="w-3/4 p-10 flex flex-col justify-center relative">
              <AnimatePresence mode="wait">
                <m.div
                  key={testimonials[index].id}
                  initial={{ opacity: 0, x: 40 }}
                  animate={{ opacity: 1, x: 0 }}
                  exit={{ opacity: 0, x: -40 }}
                  transition={{ duration: 0.6 }}
                >
                  <p className="text-gray-700 dark:text-gray-300 leading-relaxed">
                    {testimonials[index].description}
                  </p>
                  <p className="font-bold mt-3 text-sm text-teal-600">
                    {testimonials[index].name}
                  </p>
                </m.div>
              </AnimatePresence>

              {/* Navigation Arrows 
              <div className="absolute bottom-6 right-6 flex gap-4">
                <button
                  onClick={prevSlide}
                  className="p-1 rounded-full bg-gray-200 dark:bg-gray-800 hover:bg-gray-300 dark:hover:bg-gray-700"
                >
                  <ChevronLeft />
                </button>
                <button
                  onClick={nextSlide}
                  className="p-1 rounded-full bg-gray-200 dark:bg-gray-800 hover:bg-gray-300 dark:hover:bg-gray-700"
                >
                  <ChevronRight />
                </button>
              </div>
            </div>
          </div> */}
      </div>
      {/* <Footer /> */}
    </m.div>
  );
};

export default Home;
